import { AppBar, Box, Toolbar, useMediaQuery, } from '@mui/material';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';

import DepartmentPicker from '../department/DepartmentPicker';
import LoginMenu from './LoginMenu';
import NavLogo from './NavLogo';
import NavMenuDesktop from './NavMenuDesktop';
import NavMenuMobile from './NavMenuMobile';

export default function NavMenu() {
    const navigate = useNavigate();

    const { activeThemeSettings } = useSelector((state) => state.settings.theme);
    const { navigation, navigationGrouped } = useSelector((state) => state.settings.resource.navigation);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { siomSettings } = useSelector((state) => state.settings.siom);
    const { student } = useSelector((state) => state.student);
    const { userCheck } = useSelector((state) => state.user);

    const noProgramDisabledUrls = [
        resourceFinal[appLanguage].words.SCHEDULE,
        resourceFinal[appLanguage].words.REGISTER,
        resourceFinal[appLanguage].words.PROGRESS,
        resourceFinal[appLanguage].words.FAVORITES,
        resourceFinal[appLanguage].words.TIMETABLE,
    ];

    const handlePathDirection = (path) => {
        const words = resourceFinal[appLanguage].words;

        const pathMap = {
            [words.SCHEDULE]: '/agenda',
            [words.REGISTER]: '/inschrijven',
            [words.PROGRESS]: '/voortgang',
            [words.CONTACT]: '/contact',
            [words.NEWS]: '/nieuws',
            [words.FAVORITES]: '/favorieten',
            [words.INFORMATION]: '/informatie',
            [words.TIMETABLE]: '/rooster',
            [words.MANAGEMENT_ACTIVITY]: '/activiteitenbeheer',
            [words.MANAGEMENT_PROGRAM]: '/programmabeheer',
            [words.MANAGEMENT_ORGANISATION]: '/organisatiebeheer',
            [words.MANAGEMENT_TIMETABLE]: '/lesroosterbeheer',
            [words.PLANNING]: '/plannen',
            [words.MANAGEMENT_WEB]: '/webbeheer',
            [words.REPORTS_PAGE]: '/rapporten',
            [words.ADMIN_PAGE]: '/admin',
            [words.HOME]: '/',
            [words.ABOUT]: '/over',
            [words.ATTENDANCE]: '/presentie',
            [words.SEARCH_PAGE]: '/zoeken/student',
            [words.MESSAGES_PAGE]: '/berichten',
            [words.MANAGEMENT_EMPLOYEE]: '/medewerkerbeheer',
            [words.TRAVEL_COSTS]: '/reiskosten',
            [words.HISTORY]: '/historie',
        };

        return pathMap[path] || '/';
    };

    const mobileBgImage = {
        backgroundImage: theme =>
            `linear-gradient(110deg, ${theme.palette.secondary?.main} 50%, ${theme.palette.primary?.main} 50%)`
    };

    const bgImage = useMediaQuery('(min-width:900px)') ? '' : mobileBgImage;
    const filteredNavigationItems = navigation.filter(item => userCheck === 4 || !noProgramDisabledUrls.includes(item));
    const filteredNavigationGroupedItems = navigationGrouped.filter(item => userCheck === 4 || !noProgramDisabledUrls.includes(item));

    return (
        <AppBar position="static" sx={{ ...bgImage }}>
            <Toolbar disableGutters>
                <NavLogo logo={activeThemeSettings?.logo} onClick={() => navigate("/")} variant="md" />

                <NavMenuDesktop
                    navigationItems={filteredNavigationItems}
                    navigationGrouped={filteredNavigationGroupedItems}
                    resources={resourceFinal[appLanguage]}
                    handlePathDirection={handlePathDirection}
                />

                {siomSettings.useMultipleDepartments && student !== null && (
                    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <DepartmentPicker type={"compact"} />
                    </Box>
                )}

                <NavMenuMobile
                    navigationItems={filteredNavigationItems}
                    handlePathDirection={handlePathDirection}
                />

                <NavLogo logo={activeThemeSettings?.logo} onClick={() => navigate("/")} variant="xs" />

                <Box sx={{ display: 'flex', mr: 2 }}>
                    <LoginMenu />
                </Box>
            </Toolbar>
        </AppBar>
    );
}
